















































import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import FilterCard from "@/components/filter/FilterCard.vue";
import { AssetRepository, AssetEnum } from "../../lib/AssetRepository";
import { simpleDate } from "../../lib/utility/date-helper";
import { getDateFilterList } from "../../lib/utility/filter";
import {
  MrfiktivPartnerTemplateViewModelGen,
  MrfiktivAdminTemplateViewModelGen
} from "../../services/mrfiktiv/v1/data-contracts";
import { AdminTemplateModule } from "../../store/modules/admin-template.store";
import { PartnerTemplateModule } from "../../store/modules/partner-template.store";
import TemplateDetailCreateDialog from "./TemplateDetailCreateDialog.vue";

@Component({ components: { FilterCard, TemplateDetailCreateDialog } })
export default class TemplateList extends DarkModeHighlightMixin {
  @Prop()
  partnerId!: string;

  search = "";
  selected: MrfiktivPartnerTemplateViewModelGen | MrfiktivAdminTemplateViewModelGen | null = null;

  get emptyDataSrc() {
    return AssetRepository.getAsset(false, AssetEnum.emptyData);
  }

  get templates(): MrfiktivPartnerTemplateViewModelGen[] | MrfiktivAdminTemplateViewModelGen[] {
    if (this.partnerId) {
      return PartnerTemplateModule.partnerTemplates;
    } else {
      return AdminTemplateModule.adminTemplates;
    }
  }

  date(item: any): string {
    return simpleDate(item.timestamp?.created);
  }

  refresh() {
    this.$emit("refreshList");
  }

  async set(item: MrfiktivPartnerTemplateViewModelGen | MrfiktivAdminTemplateViewModelGen) {
    this.$emit("setDetail", item);
  }

  /**
   * The available categories visible in the filter menu
   */
  filterList = getDateFilterList("timestamp");

  items = this.templates.slice();

  get filteredItems(): MrfiktivPartnerTemplateViewModelGen[] | MrfiktivAdminTemplateViewModelGen[] {
    return this.items;
  }
}
